import React, { useState } from "react";
import CancelSubscriptionModal from "../../components/alerts/CancelSubscriptionModal";
import { useSelector } from "react-redux";

import { cancelSubscriptionRenewal } from "../../stripe/cancel_renewal";
import { updateUserTokensForTimestamp } from "../../utils/emptyAllTokens";
import { clearTokens } from "../../redux/tokens";
import Swal from "sweetalert2";
import { collection, doc, getDocs, updateDoc, where } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { query } from "firebase/database";
import { firestoredDB } from "../../config/firebase";
import { CButton } from "../../components/CommonComponents";

const ProfileActions = ({ deleteProfile }) => {
  const [openSubRemoveModal, setOpenSubsRemoveModal] = useState(false);
  const uid = localStorage.getItem("uid");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tokens } = useSelector((state) => state);

  const cancelSubscription = async () => {
    try {

      const res = await cancelSubscriptionRenewal(tokens?.subscriptionId);
      console.log(res, "cancelSubscription");
      if (res) {
        Swal.fire({
          icon: "success",
          title: "Subscription Cancelled",
          text: `Your Subscription is Cancelled, you can use your remaining tokens untill the end of your current billing period`,
          showConfirmButton: false,
          timer: 5000,
          confirmButtonColor: "#f0481a",
        });
        setTimeout(() =>
          window.location.reload()
          , 4000);

      } else {
        Swal.fire({
          icon: "error",
          title: `Error, Try again`,
          showConfirmButton: false,
          confirmButtonColor: "#f0481a",
        });
      }
    } catch (e) {
      Swal.fire({
        icon: "info",
        title: "Error Connecting with Stripe, Try again!",
        showConfirmButton: false,
        confirmButtonColor: "#f0481a",
      });
    }
  };

  return (
    <div className="userInfo">
      <div className="flex flex-col md:flex-row justify-around my-4 items-center gap-4 mb-4">
        {/* cancel renewal Button */}

        <CButton
          variant="skin"
          type="button"
          className="text-white w-full"
          onClick={() => {
            setOpenSubsRemoveModal(true);
          }}
          disabled={!tokens?.isActive}
        >
          Cancel Subscription
        </CButton>

        {/* <CButton className="w-full" type="button" variant="orange">
          Deactivate
        </CButton> */}
        <CButton
          type="button"
          variant="red"
          className="w-full"
          onClick={() => {
            deleteProfile();
          }}
        >
          Delete
        </CButton>
      </div>

      <CancelSubscriptionModal
        isOpen={openSubRemoveModal}
        close={cancelSubscription}
        closeModal={() => setOpenSubsRemoveModal(false)}
      />
    </div>
  );
};

export default ProfileActions;
